import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketCreateFreightShipmentEventName = 'CREATE_FREIGHT_SHIPMENT';

export const useTrackCreateFreightShipmentClick = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketCreateFreightShipmentEventName, {
      env: environment,
    });
  }, []);
};
